import React from 'react';
import { object, string, oneOfType, } from 'prop-types';
import { color, } from '../../../../legacy-tv-dls';

const PropTypes = {
  text: oneOfType([string, object]),
};
const DefaultProps = {
  text: '',
};

const TEXT_COLOR_MAP = [
  null,
  '#aaa',
  color.return.up,
  color.return.down,
];

export const TextSpan = ({ text, }) => {
  if (typeof text === 'string') {
    return <span>{text}</span>;
  }
  return (
    <span
      style={{
        color: TEXT_COLOR_MAP[text.colorCode], margin: '0 6px',
      }}
    >
      {text.text}
    </span>
  );
};

TextSpan.propTypes = PropTypes;
TextSpan.defaultProps = DefaultProps;

export default TextSpan;



// WEBPACK FOOTER //
// ./src/scenes/Adjustment/components/TextSpan/index.js